import React from 'react';
import styled from 'styled-components';
import OpenPlayersDirectory from '../../../components/playerDirectory/OpenPlayersDirectory';

const Wrap = styled.div`
  margin-top: 0.5rem;
`;

export default function HelpFindPlayersPanel() {
  return (
    <Wrap>
      <OpenPlayersDirectory embedded />
    </Wrap>
  );
}
